import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Flex, theme, Typography } from 'antd'
import { ReactNode } from 'react'

const { Text } = Typography

interface Props {
  title: ReactNode
  /** Small grey line under the title (Figma: "As of today", "Last 90 days"...). */
  caption?: ReactNode
  /** Right-aligned slot, e.g. the date-range picker of Part B. */
  extra?: ReactNode
}

/** Section title + caption of the Revenue page (Figma "Section head"). */
const SectionHead = ({ title, caption, extra }: Props) => {
  const { token } = theme.useToken()

  return (
    <Flex justify="space-between" align="center" gap={16}>
      <Flex vertical gap={4}>
        <PageTitle level={5} title={title} style={{ margin: 0 }} />
        {caption && (
          <Text style={{ fontSize: 13, color: token.colorTextTertiary }}>
            {caption}
          </Text>
        )}
      </Flex>
      {extra}
    </Flex>
  )
}

export default SectionHead
